export enum EPackageType {
	TRAY = 'tray',
	BAG = 'bag',
}

export enum EPackagingMode {
	GENERAL = 'general',
	ADDITIONAL = 'additional',
}

export enum EPackagingAssignmentType {
	DIETARY_MEAL_VARIANT = 'dietary_meal_variant',
}
